import { Navigate } from 'react-router-dom'
import { hasToken } from '@/utils/token'

interface PrivateRouteProps {
  children: React.ReactElement
}

// 路由守卫组件
const PrivateRoute = ({ children }: PrivateRouteProps) => {
  if (!hasToken()) {
    return <Navigate to="/login" replace />
  }
  return children
}

export default PrivateRoute
